// extracted by mini-css-extract-plugin
export default {"text":"TypewriterText_text__PctSt","cursor":"TypewriterText_cursor__IF8+r","blink":"TypewriterText_blink__kjU0-"};